import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify"
import QRCode from 'qrcode.react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip"
import { enforceRetentionAlert, newUETransferAppAlert } from "./App";
import { Button, Modal } from "react-bootstrap"
import ReactJson from "@microlink/react-json-view";
import useAuth from "./hook/useAuth";
import useDeepVinApi from "./hook/useDeepvinApi";
import { SignOut } from "./Signin";

export const MFASetupModal = ({user, show, setShow}) => {
  const { setAuth } = useAuth()
  const api = useDeepVinApi()
  const [mfaSecret, setMfaSecret] = useState('')
  const [email, setEmail] = useState('')
  const [errBar, setErrBar] = useState("")
  const [totp, setTotp] = useState('')

  useEffect(() => {
    if (!show) return
    api.get('/api/mfa')
    .then(({data}) => { // user's MFA instance
      // console.log("MFA: ", data)
      if (data.UserID === user.ID){
        setMfaSecret(data.MfaSecretUrl)
        setEmail(data.Email)
      }
    })
    .catch(error => console.error("API error: ", error))
  }, [show])

  const onHide = () => setShow(false)

  // get Authenticator secret Url from server to generate QR code,
  // then user can use Authentictor app to scan QR to register MFA
  const handleSubmit = () => {
    api.post("/api/mfa", {
      Email: email,
      MFACode: totp,
    })
      .then(({data}) => {
        setMfaSecret(data)
        setErrBar("")
        toast.success("MFA is set up successfully!")
  //      setDone(true)
      })
      .catch((error) => {
        // setMfaSecret("")
        setErrBar("Error: " + error)
        toast.error(error?.response?.data?.error)
      })
  }

  return (
      <Modal show={show} onHide={onHide} centered={true}>
      <div className="modal-content">
      <Modal.Header closeButton>
        <Modal.Title>User MFA Setup</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '40vh', overflowY: 'auto' }}>
      <>
        {/* <h4 class="mt-5 mb-3">Please provide a backup email (required)</h4> */}
        <div>
          
            {mfaSecret && <QRCode value={mfaSecret} />}
            {mfaSecret && <p style={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#00F' }}>Scan the QR code with Google Authenticator app and type in MFA Code from the app to verify.</p>}

            <div class="form-floating">
              <input type="text" class="form-control mb-3" id="floatingSetupMFAcode" placeholder="123456" value={totp} onChange={e => setTotp(e.target.value)} />
              <label for="floatingSetupMFAcode">MFA Code</label>
            </div>

            <div class="form-floating col-12">
              <input type="email" class="form-control mb-3" id="floatingEmail" placeholder="name@example.com" value={email} onChange={e => setEmail(e.target.value)} />
              <label for="floatingEmail">Email address for MFA backup (required)</label>
            </div>
        </div>
        <hr />
        <p>{errBar && errBar}</p>
        {/* <ReactJson src={{email, passcode, newPassword, newPassword2}} /> */}
      </>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>Submit</Button>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
      </div>
    </Modal>

  )
}

export const MFAVerify = () => {
  const [totp, setTotp] = useState('')
  const [useEmail, setUseEmail] = useState(false)
  const [errBar, setErrBar] = useState("")

  const location = useLocation();
  const navLink = location.state?.from?.pathname || "/dashboard/"
 
  const { setAuth } = useAuth()
  const api = useDeepVinApi()
  const navigate = useNavigate()
  const handleMFAVerify = async () => {

    // sign out first, ensure no stale auth data
    // SignOut(api, setAuth)

    api.post("/api/mfa/verify", {
        MFACode: totp,
        UseEmail: useEmail, 
      })
      .then(({data}) => {
        localStorage.clear()
        setAuth(data)
        navigate(navLink, { replace: true })
        enforceRetentionAlert(data)
        newUETransferAppAlert(data)
      })
      .catch((error) => {
        setAuth({})
        setErrBar("Error: " + error)
        toast.error(error.response.data.error)
      })
    }

  const handleEmailCode= async () => {
    api.get("/api/mfa/email")
      .then(({data}) => {
        setErrBar("")
        toast.success("MFA code was sent to registered email")
        //navigate("/dashboard/")
      })
      .catch((error) => {
        setErrBar("Error: " + error)
        toast.error(error.response.data.error)
      })
    }

  return (
    <>
    <div class="form-signin w-100 m-auto">
        {/* <img class="mb-4" src={logo} alt="" width="72" height="72" /> */}
        <h3 class="h3 mb-3 fw-normal">MFA Verification</h3>
    
        <div class="form-floating">
          <input type="text" class="form-control mb-3" id="floatingMFAcode" placeholder="123456" value={totp} onChange={e => setTotp(e.target.value)} />
          <label for="floatingMFAcode">MFA Code</label>
        </div>
        
        <div class="form-check text-start my-3">
          <input class="form-check-input" type="checkbox" id="flexCheckUseEmail" value={useEmail} onChange={()=>setUseEmail(!useEmail)} />
          <label class="form-check-label me-2" for="flexCheckUseEmail">
            Send code via Email
          </label>
          <button class="btn btn-outline-secondary py-0" id="btn-email-mfa" disabled={!useEmail}
            onClick={handleEmailCode}><FontAwesomeIcon icon={faCircleArrowRight}/></button>
        </div>
        
        <button class="btn btn-primary w-100 py-2" onClick={handleMFAVerify}>Submit</button>

        <p>{errBar && errBar}</p>
    </div>
    <Tooltip anchorSelect="#btn-email-mfa" place="right">Send code to registered MFA email</Tooltip>
    {/* <ReactJson src={{email, passcode}} /> */}
  </>
  )
}
